// import { connect } from "react-redux";
// import * as React from "react";
import { connect } from "react-redux";
// 订单列表
import OrderList from "../components/OrderList";

import {
  StepStatusInfo,
  MailInfo,
  Immediate,
  Destination,
  EOrderListPageType,
  EOrderPayStatus,
  getOrderStatusForFirst
} from "utils/enum/orderListFormEnum";

// 相同的配置
const commonSett = placeholder => {
  return {
    // label: "",
    placeholder,
    colSpan: 3,
    labelCol: 0,
    wrapperCol: 24,
    width: "100%"
  };
};

const mapState = state => ({
  CreateForm: state.antDemo.formDemo1,
  supplier: state.share.supplier,
  orderInfo: state.orderInfo,
  orderTotal: state.orderInfo.orderTotal,
  // 查询模式
  orderRequestMode: state.orderInfo.orderRequestMode,
  // 订单统计数据  tab栏上的
  statisticsInfoOrder: state.orderInfo.statis.orderData,
  statisticsInfoTab: state.orderInfo.statis.tabData,
  statisLoaded: state.orderInfo.statis.isLoaded,
  hotkey: state.hotkey,
  // 订单列表筛选项数据
  screeningItem: state.orderInfo.screeningItem,
  // 时间戳  根据时间戳判断是否需要渲染组件
  tableTimestamp: state.globalStatus.tiemstampMg.orderListTimestamp,
  // tab栏状态
  tabStatus: state.orderInfo.tabStatus,
  salers: state.share.user
});
// 获取交易状态组件  不同公司的子订单列表页面交易状态呈现的方式不同
const getCurrentOrderPayStatus = (
  type = EOrderListPageType.zidingdanliebiao
) => {
  const _type = Number(type);

  switch (_type) {
    case EOrderListPageType.tianmaohaiwaidian:
    case EOrderListPageType.fengongsitianmaodian:
    case EOrderListPageType.tianmaolijiangdian:
      return {
        type: 3,
        field: "orderPayStatus",
        ...commonSett("交易状态"),
        extFieldValue1: getOrderStatusForFirst(
          EOrderPayStatus.tianmao,
          "name",
          "id"
        ),
        key: "orderPayStatus"
      };
    case EOrderListPageType.shangcheng:
      return {
        type: 3,
        field: "orderPayStatus",
        ...commonSett("交易状态"),
        extFieldValue1: getOrderStatusForFirst(
          EOrderPayStatus.shangcheng,
          "name",
          "id"
        ),
        key: "orderPayStatus"
      };
    case EOrderListPageType.zidingdanliebiao:
    default:
      return {
        type: 14,
        field: "tradeSource",
        extField1: "orderPayStatusFrom",
        extField2: "orderPayStatus",
        ...commonSett("交易状态"),
        key: "orderPayStatus"
      };
  }
};

// 获取订单来源数据 type: 订单列表类型
const getCurrentOrderSource = (type = EOrderListPageType.zidingdanliebiao) => {
  const _type = Number(type);
  switch (_type) {
    case EOrderListPageType.zidingdanliebiao:
      return {
        type: 15,
        field: "primaryCategories",
        extField1: "fromSource",
        extField2: "fromSource_extField1",
        ...commonSett("订单来源"),
        key: "fromSource"
      };
    case EOrderListPageType.shangcheng:
      return {
        type: 3,
        field: "fromSource",
        ...commonSett("订单来源"),
        extField1: "storeOrderSource",
        key: "fromSource"
      };
    default:
      return {
        type: 15,
        field: "primaryCategories",
        extField1: "fromSource",
        extField2: "fromSource_extField1",
        ...commonSett("订单来源"),
        key: "fromSource"
      };
  }
};

const mapDispatch = dispatch => {
  const oi = dispatch.orderInfo;
  const antDemo = dispatch.antDemo;
  return {
    // 更新tab栏状态
    updateTabStatus: oi.updateTabStatus,
    // 获取订单列表
    getOrderList: oi.getOrderListAsync,
    // 获取订单统计数据
    getOrderListSum: oi.getOrderListSumAsync,
    // 获取筛选项列表
    getItemsList: oi.getItemsList,
    // 批量发货
    sendGoods: oi.sendGoods,
    setValue: antDemo.setValue,
    // 重置CreateForm中的数据
    resetModel: antDemo.resetModel,
    // 重置指定字段的值
    resetFieldsValue: antDemo.resetFieldsValue,
    updateHotKey: dispatch.hotkey.updateHotKey,
    // 更新页面级别的loadding
    updateLoading: dispatch.globalStatus.updateLoading,
    // 保存autocomplete数据
    saveAutoComplete: dispatch.autoComplete.saveSett,
    // 更新系统菜单状态
    updateSysMenuStatus: dispatch.globalStatus.updateSysMenuStatus,
    // 更新列表的时间戳
    updateListTimestamp: () => {
      dispatch.globalStatus.updateTimestamp({
        orderListTimestamp: new Date().getTime()
      });
    },
    // 订单列表，表单搜索部分的参数
    getFormData: (search, reset, editField, pageType = 1, searchStr = "") => {
      const isExp = pageType == 13 //是否特殊表格
      if (isExp) {
        return [
          {
            label: "出发日期：",
            type: 10,
            field: "goTimeStart",
            extField1: "goTimeEnd",
            colSpan: 5,
            labelCol: 8,
            wrapperCol: 16,
            key: "goTimeStart",
            // 显示今天之后的日期
            extFieldValue2: true
          },
          {
            type: 3,
            field: "headId",
            extField1: "user",
            ...commonSett("客服"),
            key: "headId"
          },
          {
            type: 0,
            field: "account",
            ...commonSett("客人账号"),
            key: "account"
          },
          {
            type: 13,
            field: "countryId",
            extField1: "cityId",
            extField2: "area",
            ...commonSett("国家城市"),
            key: "countryId"
          },
          {
            label: "",
            type: 17,
            field: "detail1",
            value: "",
            colSpan: 8,
            // 偏移栅格位置
            // offset: 1,
            labelCol: 0,
            wrapperCol: 24,
            extFieldValue1: "搜索 Enter",
            extFieldValue2: "重置 Del",
            extFieldValue3: '  ',
            // 重置
            extFieldValue4: reset, // this.onReset,
            // 编辑筛选项
            // extFieldValue5: editField, // this.onEditField,
            // 搜索
            onClick: search //this.search
          }
        ]
      }
      return [
        {
          label: "下单日期：",
          type: 10,
          field: "submitDateStart",
          extField1: "submitDateEnd",
          colSpan: 5,
          labelCol: 8,
          wrapperCol: 16,
          key: "submitDateStart"
        },
        {
          label: "审核日期：",
          type: 10,
          field: "verifyTimeStart",
          extField1: "verifyTimeEnd",
          colSpan: 5,
          labelCol: 8,
          wrapperCol: 16,
          key: "verifyTimeStart"
        },
        {
          label: "出发日期：",
          type: 10,
          field: "goTimeStart",
          extField1: "goTimeEnd",
          colSpan: 5,
          labelCol: 8,
          wrapperCol: 16,
          key: "goTimeStart",
          // 显示今天之后的日期
          extFieldValue2: true
        },
        getCurrentOrderPayStatus(pageType),
        {
          type: 3,
          field: "stepStatus",
          ...commonSett("分阶状态"),
          extFieldValue1: StepStatusInfo,
          key: "stepStatus"
        },
        // 占位不做渲染
        { type: -1, colSpan: 3 },
        {
          type: 0,
          field: "itemNumber",
          ...commonSett("子订单编号"),
          key: "itemNumber"
        },
        {
          type: 3,
          field: "headId",
          extField1: "user",
          ...commonSett("客服"),
          key: "headId"
        },
        {
          type: 3,
          field: "isMail",
          ...commonSett("确认函"),
          extFieldValue1: MailInfo,
          key: "isMail"
        },
        {
          type: 13,
          field: "countryId",
          extField1: "cityId",
          extField2: "area",
          ...commonSett("国家城市"),
          key: "countryId"
        },
        {
          type: 3,
          field: "categoryId",
          ...commonSett("商品分类"),
          extField1: "productCate",
          key: "categoryId"
        },
        // 订单来源
        getCurrentOrderSource(pageType),
        {
          type: 3,
          field: "isImmediate",
          ...commonSett("即时确认"),
          extFieldValue1: Immediate,
          key: "isImmediate"
        },
        // 占位不做渲染
        { type: -1, colSpan: 3 },
        {
          type: 0,
          field: "contactName",
          ...commonSett("联系人姓名"),
          key: "contactName"
        },
        {
          type: 0,
          field: "phone",
          ...commonSett("联系电话"),
          key: "phone"
        },
        {
          type: 0,
          field: "tMallCode",
          ...commonSett("天猫短码"),
          key: "tMallCode"
        },
        {
          type: 0,
          field: "skuName",
          ...commonSett("SKU名称"),
          key: "skuName"
        },
        {
          type: 3,
          field: "supplierCode",
          ...commonSett("供应商"),
          extField1: "supplier",
          key: "supplierCode"
        },
        {
          type: 20,
          field: "travelCompany",
          ...commonSett("行程公司"),
          key: "travelCompany"
        },
        {
          type: 0,
          field: "addRemark",
          ...commonSett("新增详情"),
          key: "addRemark"
        },
        // 占位不做渲染
        { type: -1, colSpan: 3 },
        {
          type: 0,
          field: "groupNumber",
          ...commonSett("团号"),
          key: "groupNumber"
        },
        {
          type: 0,
          field: "account",
          ...commonSett("客人账号"),
          key: "account"
        },
        {
          type: 18, //16,
          field: "orderStatus",
          ...commonSett("订单状态"),
          colSpan: 6,
          key: "orderStatus"
        },
        {
          type: 19,
          field: "tag",
          ...commonSett("订单标签"),
          colSpan: 6,
          key: "tag"
        },
        {
          type: 3,
          field: "destination",
          ...commonSett("目的地"),
          key: "destination",
          extFieldValue1: Destination
        },
        {
          label: "",
          type: 17,
          field: "detail1",
          value: "",
          colSpan: 8,
          // 偏移栅格位置
          // offset: 1,
          labelCol: 0,
          wrapperCol: 24,
          extFieldValue1: "搜索 Enter",
          extFieldValue2: "重置 Del",
          extFieldValue3: "编辑筛选项",
          // 重置
          extFieldValue4: reset, // this.onReset,
          // 编辑筛选项
          extFieldValue5: editField, // this.onEditField,
          // 搜索
          onClick: search //this.search
        }
      ];
    },
  };
};

export default connect(
  mapState,
  mapDispatch
)(OrderList);
